import React from "react";

const ACCENT_STYLES = {
    blue: "bg-indigo-50 text-indigo-600 ring-indigo-100",
    green: "bg-emerald-50 text-emerald-600 ring-emerald-100",
    amber: "bg-amber-50 text-amber-600 ring-amber-100",
    red: "bg-red-50 text-red-600 ring-red-100",
    purple: "bg-violet-50 text-violet-600 ring-violet-100",
};

const StatsCard = ({
    title,
    value,
    icon: Icon,
    accent = "blue",
    className = "",
}) => {
    const accentClass = ACCENT_STYLES[accent] || ACCENT_STYLES.blue;

    return (
        <article
            className={`min-w-0 rounded-2xl border border-slate-200 bg-white p-3 shadow-sm sm:p-4 ${className}`}
        >
            <div className="flex items-center gap-2.5 sm:gap-3">
                {Icon && (
                    <span
                        className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-xl ${accentClass}`}
                    >
                        <Icon size={20} aria-hidden="true" />
                    </span>
                )}

                <div className="min-w-0">
                    <p className="text-xs font-semibold text-slate-600 sm:text-sm">
                        {title}
                    </p>
                    <p className="mt-1 truncate text-xl font-bold text-slate-900 sm:text-2xl">
                        {value ?? "--"}
                    </p>
                </div>
            </div>
        </article>
    );
};

export default StatsCard;
